import { call, put, takeLatest } from "redux-saga/effects";
import * as actionTypes from "../ActionTypes";

import {
  fetchChurchesSuccess,
  fetchChurchesFailure,
  saveChurchSuccess,
  saveChurchFailure,
  deleteChurchSuccess,
  deleteChurchFailure,
  updateChurchSuccess,
  updateChurchFailure,
  assignChurchAdminSuccess,
  assignChurchAdminFailure,
  fetchChurchByIdSuccess,
  fetchChurchByIdFailure,
} from "./actions.js";

import {
  fetchChurches,
  saveChurch,
  deleteChurch,
  updateChurch,
  assignChurchAdmin,
  fetchChurchById,
} from "./churches";

// 🔹 Fetch Churches
// 🔹 Fetch Churches
// 🔹 Fetch Churches Saga (cleaned)
function* fetchChurchesSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const callback = action.payload?.callback || action.callback;


    const data = yield call(fetchChurches, apiPayloadRequest || {});

    yield put(fetchChurchesSuccess(data?.data || []));

    if (typeof callback === "function") {
      callback({
        type: 1,
        data: data?.data,
        totalRecords: data?.totalRecords,
      });
    }
  } catch (error) {
    yield put(fetchChurchesFailure(error.message));
    const callback = action.payload?.callback || action.callback;
    if (typeof callback === "function") {
      callback({ type: 0, error: error.message });
    }
  }
}




// 🔹 Save Church
function* saveChurchSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload;
        const data = yield call(saveChurch, apiPayloadRequest);

    yield put(saveChurchSuccess(data?.data || []));

    // ✅ Correct callback reference
    if (typeof action.callback === "function") {
      action.callback({ type: 1, data: data?.data });
    }
  } catch (error) {
    yield put(saveChurchFailure(error.message));

    // ✅ Correct callback reference
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}


// 🔹 Delete Church
function* deleteChurchSaga(action) {
  try {
    const { _id, callback } = action.payload;
    const data = yield call(deleteChurch, _id);

    if (data?.type === 1) {
      yield put(deleteChurchSuccess({ _id }));
      if (callback) callback(data);
    } else {
      yield put(deleteChurchFailure(data?.error || "Delete failed"));
      if (callback) callback(data);
    }
  } catch (error) {
    yield put(deleteChurchFailure(error.message));
    if (action.payload.callback) action.payload.callback({ type: 0, error: error.message });
  }
}

// 🔹 Update Church
function* updateChurchSaga(action) {
  try {
    const { payload, callback } = action;
    const data = yield call(updateChurch, payload);

    yield put(updateChurchSuccess(data?.data || payload));
    if (callback) callback({ type: 1, data: data?.data });
  } catch (error) {
    yield put(updateChurchFailure(error.message));
    if (action.callback) action.callback({ type: 0, error: error.message });
  }
}

// 🔹 Assign Church Admin
function* assignChurchAdminSaga(action) {
  try {
    const { apiPayloadRequest } = action.payload || {};
    const data = yield call(assignChurchAdmin, apiPayloadRequest);
    const normalizedResponse = {
      ...data,
      type:
        String(data?.type) === "1" ||
        /success/i.test(data?.message || "") ||
        /success/i.test(data?.data?.[0] || "")
          ? 1
          : 0,
    };

    yield put(assignChurchAdminSuccess(data?.data || data));

    if (typeof action.callback === "function") {
      action.callback(normalizedResponse);
    }
  } catch (error) {
    yield put(assignChurchAdminFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

// 🔹 Fetch Church by ID
function* fetchChurchByIdSaga(action) {

  try {
    const { _id } = action.payload;
    const data = yield call(fetchChurchById, _id);


    const church = Array.isArray(data?.data) ? data.data[0] : null;

    if (church) {
      yield put(fetchChurchByIdSuccess(church));
      if (typeof action.callback === "function") {
        action.callback({ type: 1, data: church });
      }
    } else {
      throw new Error("Church not found");
    }
  } catch (error) {
        yield put(fetchChurchByIdFailure(error.message));
    if (typeof action.callback === "function") {
      action.callback({ type: 0, error: error.message });
    }
  }
}

export default function* churchesWatcherSaga() {
  yield takeLatest(actionTypes.FETCH_CHURCHES_REQUEST, fetchChurchesSaga);
  yield takeLatest(actionTypes.SAVE_CHURCH_REQUEST, saveChurchSaga);
  yield takeLatest(actionTypes.DELETE_CHURCH_REQUEST, deleteChurchSaga);
  yield takeLatest(actionTypes.UPDATE_CHURCH_REQUEST, updateChurchSaga);
  yield takeLatest(actionTypes.ASSIGN_CHURCH_ADMIN_REQUEST, assignChurchAdminSaga);
  yield takeLatest(actionTypes.FETCH_CHURCH_BY_ID_REQUEST, fetchChurchByIdSaga);
}
